import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { INTERCONEXION_GATEWAY, INTERCONEXION_ICOIJ, INTERCONEXION_METHOD_DELETEDOCAUTOENROLAMIENTO, INTERCONEXION_METHOD_GETDEPENDENCIAORG, INTERCONEXION_METHOD_GETPALABRAS, INTERCONEXION_METHOD_REGISTRARAUTOENROLAMIENTO, INTERCONEXION_METHOD_UPDATETRANSACTIONDOC } from '../../app-module.token';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { BaseReponseGeneric } from '../../commons/class/BaseReponseGeneric.interface';
import { GetTypeOrganismDTO, insertPostAutoEnrolamiento } from './autoEnrolamiento.interface';

@Injectable({ providedIn: 'root' })
export class autoEnrolamientoService {


    private httpService: HttpService = inject(HttpService);
    protected icoj_gateway: string = inject(INTERCONEXION_GATEWAY);
    protected icoj: string = inject(INTERCONEXION_ICOIJ);
    protected registrarPost: string = inject(INTERCONEXION_METHOD_REGISTRARAUTOENROLAMIENTO);
    protected getPalabras: string = inject(INTERCONEXION_METHOD_GETPALABRAS);
    protected updateTransaction: string = inject(INTERCONEXION_METHOD_UPDATETRANSACTIONDOC);
    protected deleteDoc: string = inject(INTERCONEXION_METHOD_DELETEDOCAUTOENROLAMIENTO);
    protected getDependenciaOrg: string = inject(INTERCONEXION_METHOD_GETDEPENDENCIAORG);

    /**
     * Obtiene las dependencias organizacionales
     * @param s 
     * @returns 
     */
    getDependenciasOrg(s: string): Observable<BaseReponseGeneric<GetTypeOrganismDTO[]>> {
        const headers = new HttpHeaders();
        const url = `${this.icoj_gateway}${this.icoj}${this.getDependenciaOrg}/${s}`;
        return this.httpService.getRequest(url, { headers }) as Observable<BaseReponseGeneric<GetTypeOrganismDTO[]>>;
    }

    /**
     * Registra un nuevo autoenrolamiento
     * @param registro 
     * @returns 
     */
    postRegistrar(registro: insertPostAutoEnrolamiento): Observable<BaseReponseGeneric<number>> {
        const headers = new HttpHeaders();
        const url = `${this.icoj_gateway}${this.icoj}${this.registrarPost}`;
        return this.httpService.postRequest(url, registro, { headers }) as Observable<BaseReponseGeneric<number>>;
    }

    /**
     * Obtiene las palabras validadas
     * @returns 
     */
    getValidarPalabras(): Observable<BaseReponseGeneric<string[]>> {
        const headers = new HttpHeaders();
        const url = `${this.icoj_gateway}${this.icoj}${this.getPalabras}`;
        return this.httpService.getRequest(url, headers) as Observable<BaseReponseGeneric<string[]>>
    }

    /**
     * Actualiza el guid de la transacción para un autoenrolamiento específico
     * @param guid 
     * @param idTransaction 
     * @returns 
     */
    updateIdTransaction(guid: string, idTransaction: number): Observable<BaseReponseGeneric<boolean>> {
        const headers = new HttpHeaders();
        const url = `${this.icoj_gateway}${this.icoj}${this.updateTransaction}/${guid}/${idTransaction}`;
        return this.httpService.putRequest(url, {}, headers) as Observable<BaseReponseGeneric<boolean>>;
    }

    /**
     * Elimina documentos de la pantalla
     * @param idDocument 
     * @returns 
     */
    EliminarDocumentosPantalla(idDocument: number): Observable<BaseReponseGeneric<boolean>> {
        const url = `${this.icoj_gateway}${this.icoj}${this.deleteDoc}/${idDocument}`;
        return this.httpService.deleteRequest(url) as Observable<BaseReponseGeneric<boolean>>;
    }
}